import _ from 'underscore';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ActionLink } from './util/action-link';
import { DismissBtn } from './util/dismiss-btn';
import {
  severityTypes,
  alertQueueIconCssClassName,
  alertQueueIconCssClasses,
  scenarioNames,
  notificationLogKeys,
  MessageType,
} from './util/constants';

export const Notification = (props) => {
  const notificationLogContent = JSON.stringify(_.pick(props, notificationLogKeys));

  const actions = props.actionList.map(action => (
    <ActionLink
      id={props.id}
      key={action.text}
      ariaLabel={action.text === props.i18n.getString(_TL_('Learn more')) ? props.i18n.getString(_TL_('Learn more about {{title}} notification'), { title: props.title }) : action.text}
      {...action}
      scenarioName={scenarioNames.ActionLink}
      content={notificationLogContent}
      actionCallback={props.actionCallback}
    />
  ));

  useEffect(() => {
    const {
      logger,
      logContent,
    } = props;

    if (logger && logContent) {
      try {
        const content = logContent(`id=${props.id}, title=${props.title}, message=${props.message}, notificationSource=${props.notificationSource}, notificationTypeId=${props.notificationTypeId}, uiDeliveryId=${props.uiDeliveryId}`);
        logger.trace(scenarioNames.NotificationCard, content);
      } catch (error) {
        logger.trace(scenarioNames.NotificationCard, logContent('NotificationLogFailed'));
      }
    }
  }, []);

  return (
    <div className="notification-item">
      <div className="left">
        <span
          className={
            classNames(alertQueueIconCssClassName, alertQueueIconCssClasses[props.severity])
          }
        />
      </div>
      <div className="center">
        <div role="heading" aria-level="4" className="title">
          {props.title}
        </div>
        <span className="message">
          {
            props.messageType === MessageType.ReactComponent ?
              <props.message logger={props.logger} logContent={props.logContent} scenarioNames={scenarioNames} /> :
              <span dangerouslySetInnerHTML={{ __html: props.message }} />
          }
        </span>
        <div className="actions">
          {actions}
          {props.isUINext && (
            <ActionLink
              id={props.id}
              text={props.i18n.getString(_TL_('Dismiss'))}
              ariaLabel={props.i18n.getString(_TL_('Dismiss {{title}} notification'), { title: props.title })}
              action={event => props.dismissAction(props.id, event)}
              scenarioName={scenarioNames.CommonDismiss}
              content={notificationLogContent}
              actionCallback={props.actionCallback}
              extraClassNames={['notification-queue-item-action-dismiss']}
            />
          )}
          {!props.isUINext && (
            <div className="right">
              <DismissBtn
                id={props.id}
                dismissAction={props.dismissAction}
                content={notificationLogContent}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Notification.propTypes = {
  severity: PropTypes.oneOf(severityTypes).isRequired,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  actionList: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  actionCallback: PropTypes.func.isRequired,
  dismissAction: PropTypes.func,
  isUINext: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    trace: PropTypes.func,
  }),
  logContent: PropTypes.func,
};

Notification.defaultProps = {
  actionList: [],
  dismissAction: _.noop,
  logger: {
    trace: _.noop,
  },
  logContent: _.noop,
};
